// extracted by mini-css-extract-plugin
module.exports = {"btnEdit":"productslist_btnEdit__3U7zV"};